// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__vxEi3","signatureBlock":"Footer_signatureBlock__WzB1Q","signature":"Footer_signature__2ko4b"};